var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBack = function SvgIconBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4 8a1 1 0 0 1 1-1h3.826C13.317 7 17 10.559 17 15v1a1 1 0 1 1-2 0v-1c0-3.29-2.74-6-6.174-6H5a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.177 4.006c0-.441-.514-.67-.83-.37L2.157 7.63c-.21.2-.21.54 0 .74l4.19 3.994c.316.3.83.071.83-.37z"
  })));
};
export default SvgIconBack;